/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.commerce.buyer.portal.rpc.BuyerBillingDataRpc
 */

export const getPaymentMethodsRpc = {
  serviceName: 'com.hubspot.commerce.buyer.portal.rpc.BuyerBillingDataRpc',
  rpcName: 'getPaymentMethods',
  auth: 'external',
  fingerprint: 'YN_2Q-8GqoWZFR9yZ1Y_YEWCN6N5rP_v',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getSubscriptionsRpc = {
  serviceName: 'com.hubspot.commerce.buyer.portal.rpc.BuyerBillingDataRpc',
  rpcName: 'getSubscriptions',
  auth: 'external',
  fingerprint: 'r0IRcWMvmJnbE1SkpjIKZkWCN6N5rP_v',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getInactiveSubscriptionsRpc = {
  serviceName: 'com.hubspot.commerce.buyer.portal.rpc.BuyerBillingDataRpc',
  rpcName: 'getInactiveSubscriptions',
  auth: 'external',
  fingerprint: 'r0IRcWMvmJnbE1SkpjIKZkWCN6N5rP_v',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getInvoicesRpc = {
  serviceName: 'com.hubspot.commerce.buyer.portal.rpc.BuyerBillingDataRpc',
  rpcName: 'getInvoices',
  auth: 'external',
  fingerprint: 'VP4iiKB53Wgl7qi3tRHjBUWCN6N5rP_v',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getCommercePaymentsRpc = {
  serviceName: 'com.hubspot.commerce.buyer.portal.rpc.BuyerBillingDataRpc',
  rpcName: 'getCommercePayments',
  auth: 'external',
  fingerprint: 'iu-RCY-jEH-Dz2XheWyAbkWCN6N5rP_v',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getFailedCommercePaymentsRpc = {
  serviceName: 'com.hubspot.commerce.buyer.portal.rpc.BuyerBillingDataRpc',
  rpcName: 'getFailedCommercePayments',
  auth: 'external',
  fingerprint: 'SCcBxS9bmwCwHbuKxD_0J0WCN6N5rP_v',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getQuotesRpc = {
  serviceName: 'com.hubspot.commerce.buyer.portal.rpc.BuyerBillingDataRpc',
  rpcName: 'getQuotes',
  auth: 'external',
  fingerprint: '2lJTwiWdAYSMaMT5hDCprEWCN6N5rP_v',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getSubscriptionRpc = {
  serviceName: 'com.hubspot.commerce.buyer.portal.rpc.BuyerBillingDataRpc',
  rpcName: 'getSubscription',
  auth: 'external',
  fingerprint: '28U52viPGBQp5XyGyiQdJEWCN6N5rP_v',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getInvoiceRpc = {
  serviceName: 'com.hubspot.commerce.buyer.portal.rpc.BuyerBillingDataRpc',
  rpcName: 'getInvoice',
  auth: 'external',
  fingerprint: '28U52viPGBRiys42iJfDuEWCN6N5rP_v',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};